var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.92774 10.6364C6.92774 8.52353 8.64053 6.81073 10.7534 6.81073C12.8662 6.81073 14.579 8.52353 14.579 10.6364C14.579 12.7492 12.8662 14.462 10.7534 14.462C8.64053 14.462 6.92774 12.7492 6.92774 10.6364ZM10.7534 5.1828C7.74145 5.1828 5.2998 7.62445 5.2998 10.6364C5.2998 13.6483 7.74145 16.0899 10.7534 16.0899C13.7653 16.0899 16.2069 13.6483 16.2069 10.6364C16.2069 7.62445 13.7653 5.1828 10.7534 5.1828ZM16.7418 15.4737C16.4239 15.1558 15.9086 15.1558 15.5907 15.4737C15.2728 15.7916 15.2728 16.3069 15.5907 16.6248L17.9105 18.9446C18.2284 19.2625 18.7437 19.2625 19.0616 18.9446C19.3795 18.6267 19.3795 18.1114 19.0616 17.7935L16.7418 15.4737Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search.8b77877bbf775f5dd6ab81573dcbfa4a.svg";